<template>
  <li :class="[baseCss, 'w-full']">
    <container :class="['whitespace-normal']">
      <slot />
    </container>
  </li>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'CarouselSlide',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('carousel-slide', [])
    }
  }
}
</script>
<style>
.bcq-carousel .bcq-carousel-slide
{
  aspect-ratio: inherit;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/carousel-slide/carousel-slide.vue